import { RecursosEnum } from "../enums/recusos";

type Usuario = { recursos?: string[] } | null | undefined;

export const useAccess = (usuario?: Usuario, isAdmin?: boolean) => {
  const hasResource = (resource?: string | RecursosEnum) =>
    !!(resource && usuario?.recursos?.includes(String(resource)));

  const hasAccess = (resource?: string | RecursosEnum) =>
    !!(isAdmin || (resource && usuario?.recursos?.includes(String(resource))));

  return { hasResource, hasAccess };
};
